import i18n from "i18next";

export const CampaignDetailService = () => {
  const getExportBdelightTemplate = {
    [i18n.t("campaignDetailsPage.clientNameEng")]: "clientFullNameEng",
    [i18n.t("campaignDetailsPage.clientNameHk")]: "clientFullNameChi",
    [i18n.t("campaignDetailsPage.dateOfBirth")]: "dateOfBirth",
    [i18n.t("campaignDetailsPage.birthdayMonth")]: "birthdayMonth",
    [i18n.t("campaignDetailsPage.customerLanguagePreference")]:
      "languageForCommunication",
    [i18n.t("campaignDetailsPage.latestPolicyIssueDate")]:
      "latestPolicyIssueDate",
    [i18n.t("campaignDetailsPage.firstPolicyIssueDate")]:
      "firstPolicyIssueDate",
    [i18n.t("campaignDetailsPage.latestIssuedPolicy")]: "latestIssuedPolicy",
    [i18n.t("campaignDetailsPage.noOfInForcePolicy")]: "noOfInForcePolicy",
    [i18n.t("campaignDetailsPage.lastYearPremium")]: "lastYearPremium",
    [i18n.t("campaignDetailsPage.thisYearPremium")]: "thisYearPremium",
    [i18n.t("campaignDetailsPage.brokerCode")]: "servAgentCode",
    [i18n.t("campaignDetailsPage.brokerName")]: "servAgentName",
    [i18n.t("campaignDetailsPage.agentCode")]: "trCode",
    [i18n.t("campaignDetailsPage.agentName")]: "trNameEng",
    [i18n.t("campaignDetailsPage.salesManager1")]: "salesManager1",
    [i18n.t("campaignDetailsPage.optOut")]: "optOut",
    [i18n.t("campaignDetailsPage.picsIndicator")]: "picsIndicator",
    [i18n.t("campaignDetailsPage.picsIndicatorDate")]: "picsIndicatorDate",
    [i18n.t("campaignDetailsPage.directMarketingFtl")]: "directMarketingFtl",
    [i18n.t("campaignDetailsPage.directMarketingFtlDate")]:
      "directMarketingFtlDate",
    [i18n.t("campaignDetailsPage.directMarketingNwg")]: "directMarketingNwg",
    [i18n.t("campaignDetailsPage.directMarketingNwgDate")]:
      "directMarketingNwgDate",
    [i18n.t("campaignDetailsPage.haveP10Account")]: "haveP10Account",
    [i18n.t("campaignDetailsPage.customerCommunication")]:
      "customerCommunication",
  };

  const getExportCiconvTemplate = {
    [i18n.t("campaignDetailsPage.latestIssuedPolicy")]: "latestIssuedPolicy",
    [i18n.t("campaignDetailsPage.currentPlanCode")]: "currentPlanCode",
    [i18n.t("campaignDetailsPage.title")]: "title",
    [i18n.t("campaignDetailsPage.clientNameEng")]: "clientFullNameEng",
    [i18n.t("campaignDetailsPage.areaCode")]: "mobileAreaCode",
    [i18n.t("campaignDetailsPage.mobile")]: "mobile",
    [i18n.t("campaignDetailsPage.email")]: "email",
    [i18n.t("campaignDetailsPage.picsStatus")]: "picsIndicator",
    [i18n.t("campaignDetailsPage.existingCustomer")]: "existingCustomer",
    [i18n.t("campaignDetailsPage.partyId")]: "partyId",
    [i18n.t("campaignDetailsPage.regionCode")]: "servAgentRegion",
    [i18n.t("campaignDetailsPage.brokerCode")]: "servAgentCode",
    [i18n.t("campaignDetailsPage.brokerName")]: "servAgentName",
    [i18n.t("campaignDetailsPage.agentCode")]: "trCode",
    [i18n.t("campaignDetailsPage.agentName")]: "trNameEng",
    [i18n.t("campaignDetailsPage.brokerEmail")]: "servAgentEmail",
  };

  const getExportKdollarTemplate = {
    [i18n.t("campaignDetailsPage.partyId")]: "partyId",
    [i18n.t("campaignDetailsPage.clientNameHk")]: "clientFullNameChi",
    [i18n.t("campaignDetailsPage.clientNameEng")]: "clientFullNameEng",
    [i18n.t("campaignDetailsPage.email")]: "email",
    [i18n.t("campaignDetailsPage.mobile")]: "mobile",
    [i18n.t("campaignDetailsPage.customerLanguagePreference")]:
      "languageForCommunication",
    [i18n.t("campaignDetailsPage.latestIssuedPolicy")]: "latestIssuedPolicy",
    [i18n.t("campaignDetailsPage.customerCommunication")]:
      "communicationChannel",
    [i18n.t("campaignDetailsPage.kDollar")]: "kdollar",
    [i18n.t("campaignDetailsPage.kDollarMembershipNumber")]:
      "kdollarMembership",
    [i18n.t("campaignDetailsPage.redemptionStatus")]: "redemptionStatus",
  };

  const getUploadKdollarTemplate = {
    "Party ID": "partyId",
    "Policyowner name (TC)": "clientFullNameChi",
    "Policyowner name (EN)": "clientFullNameEng",
    "Policyowner Email": "email",
    "Policyowner Mobile": "mobile",
    "Customer Language Preference (TC/SC/EN)": "languageForCommunication",
    "Reference Policy No.": "latestIssuedPolicy",
    "Customer communication (eDM/MMS)": "communicationChannel",
    "Broker/CA Code": "servAgentCode",
    "Broker/CA Name": "servAgentName",
    "K Dollar": "kDollar",
    "K Dollar membership number": "kDollarMembership",
    "Redemption Status": "redemptionStatus",
  };

  const getUploadCiconvTemplate = {
    "Policy Number": "latestIssuedPolicy",
    "Current Plan Code": "currentPlanCode",
    Title: "title",
    "Client Name": "clientFullNameEng",
    "Area Code": "mobileAreaCode",
    Mobile: "mobile",
    Email: "email",
    "PICS Status": "picsIndicator",
    "Existing Customer": "existingCustomer",
    "Customer / Party ID": "partyId",
    "Region Code": "servAgentRegion",
    "Broker/CA Code": "servAgentCode",
    "Broker/CA Name": "servAgentName",
    "Broker Contact (email)": "servAgentEmail",
  };

  return {
    getExportBdelightTemplate,
    getExportCiconvTemplate,
    getExportKdollarTemplate,
    getUploadKdollarTemplate,
    getUploadCiconvTemplate,
  };
};

export default CampaignDetailService;
